import request from './index'

export const hideMultiTask = (missionid,isUse)=>{
    return request({
        url:"/work/missionMultiHidden",
        method:"post",
        data:{
            missionId:missionid,
			isUse:isUse
        }
    })
}

export const hideTask = (missionid,isUse)=>{
    return request({
        url:"/work/missionHidden",
        method:"post",
        data:{
            missionId:missionid,
			isUse:isUse
        }
    })
}


export const deleteMultiTask = (missionid)=>{
    return request({
        url:"/work/missionMultiDelete",
        method:"post",
        data:{
            missionId:missionid
        }
    })
}

export const deleteTask = (missionid)=>{
    return request({
        url:"/work/missionDelete",
        method:"post",
        data:{
            missionId:missionid
        }
    })
}

export const execMultiTask = (carId,missionid)=>{
    return request({
        url:"/work/missionMultiExecute",
        method:"post",
        data:{
            carid:carId,
            missionId:missionid,
        }
    })
}

export const multiTaskListPage=(listQuery)=>{
    return request({
        url:"/work/multiListPage",
        method:"post",
        data:{
           entityId: listQuery.entityId,
           pageIndex: listQuery.pageIndex,
           pageSize: listQuery.pageSize,
           params: listQuery.params,
           fuzzySearch: listQuery.fuzzySearch
        }
    })
}



// 根据地图名称查看对应任务
export const taskList = (missionName) =>{
	return request({
		url: '/work/listMission',
		method: 'post',
		data: {
		    missionName: missionName
		}
	})
}

export const execTask = (carId,missionid)=>{
    return request({
        url:"/work/missionExecute",
        method:"post",
        data:{
            carid:carId,
            missionId:missionid,
        }
    })
}

export const taskListPage=(listQuery)=>{
    return request({
        url:"/work/listPage",
        method:"post",
        data:{
           entityId: listQuery.entityId,
           pageIndex: listQuery.pageIndex,
           pageSize: listQuery.pageSize,
           params: listQuery.params,
           fuzzySearch: listQuery.fuzzySearch,
		   carid:listQuery.carid
        }
    })
}

// export const taskListPage=(carId,listQuery)=>{
//     return request({
//         url:"/task/listPage/"+carId,
//         method:"post",
//         data:{
//             command_id: 74,
//             pageIndex: listQuery.pageIndex,
//             pageSize: listQuery.pageSize,
//         }
//     })
// }

// export const addTask = task=>{
//     return request({
//         url:"/tasks/addTask",
//         method:"post",
//         data:{
//             command_id:72,
//             task:task,
//         }
//     })
// }

// export const delTask = task=>{
//     return request({
//         url:"/tasks/deleteTask",
//         method:"delete",
//         data:{
//             command_id:75,
//             task:task,
//         }
//     })
// }